const states = {
  NO_DOCUMENT_UPLOADED: 0,
  HAS_UPLOADED_DOCUMENT: 1,
};

export default states;
